<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["BB"]["BB"]}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <label class="searchLabel">{{this.getLanguage["SEO"]["BN"]}} :</label>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroup2"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :clearable="false"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="obj_holdAGIT"
                                            @input="AgentGroupChange" />

                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["BAL"]["C"]}} :</label>
                                <treeselect :multiple="true"
                                            :defaultExpandLevel="Infinity"
                                            valueConsistsOf='LEAF_PRIORITY'
                                            :placeholder="this.utilGetDDLanguage('TD.C')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            :options="dd_currency_s"
                                            :limit=1
                                            v-model="arry_holdcur" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['BB']["BBL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2">{{getLanguage[["GL"]]["NO"]}}</th>
                                <th rowspan="2">{{this.getLanguage["BB"]["BN"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BB"]["D"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);border-top-right-radius:5px;">{{this.getLanguage["BB"]["W"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BB"]["C"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BB"]["B"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BB"]["C"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-left: 1.5px solid rgb(157, 157, 171); border-bottom-right-radius: 5px;">{{this.getLanguage["BB"]["B"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2">{{getLanguage[["GL"]]["NO"]}}</th>
                                <th rowspan="2">{{this.getLanguage["BB"]["BN"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BB"]["D"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);border-top-right-radius:5px;">{{this.getLanguage["BB"]["W"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BB"]["C"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BB"]["B"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BB"]["C"]}}</th>
                                <th id="nestedTableR2" class="tableCtnRight" style="border-left: 1.5px solid rgb(157, 157, 171); border-bottom-right-radius: 5px;">{{this.getLanguage["BB"]["B"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="obj_holdAGIT == null && arry_holdcur.length <=0 || bool_isSearch == false ">{{ this.getLanguage["BB"]["PSAGC"] }}</td>
                        <td colspan="100%" v-if=" arry_bl.length <=0 && bool_isSearch == true">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_bl" v-bind:key="index">
                            <td>{{ CountItem(index+1)}}</td>
                            <td>{{ data.BN}} ({{data.BA}})</td>
                            <td class="tableCtnRight">{{ checkData(data.CS)}}</td>
                            <td class="tableCtnRight" v-if="data.DS!=null">{{ formatNumber(data.BDB, 2, checkData(data.CS)) }}</td>
                            <td class="tableCtnRight" v-else>{{ formatNumber(data.BDB, 2, checkData(data.CS)) }}</td>
                            <td class="tableCtnRight">{{ checkData(data.CS)}}</td>
                            <td class="tableCtnRight" v-if="data.DS!=null">{{ formatNumber(data.BWB, 2, checkData(data.CS)) }}</td>
                            <td class="tableCtnRight" v-else>{{ formatNumber(data.BWB, 2, checkData(data.CS)) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import DateRangePicker from 'vue2-daterange-picker'
    //you need to import the CSS manually (in case you want to override it)
    import Loading from 'vue-loading-overlay';
    import { mapGetters, mapActions } from 'vuex'
    import { required, minLength, between, url } from 'vuelidate/lib/validators'
    import { loadingFullScreen } from '@/modules/Constant.js'
    import Vue from 'vue'
    //Vue.use(require('vue-shortkey'))
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading
        },
        props: {

        },
        data() {
            return {
                bool_isAMV: false, // Add Modal Visible
                int_lblPage: 1,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                timeout: null,
                //the parameter of getList()
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_RC: 100, //Row Count
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                str_FV: [{ F: "bn" }, { F: "mind_from" }, { F: "maxd_to" }, { F: "minw" }, { F: "maxw" }], //Filter Value
                //ctrl Page valuev (A return Data )
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                //array hold data
                bool_isSearch: false,
                obj_holdAGIT: null,
                //dd_currency_s: [{ id: 'all', label: 'All Currency', children: [] }],//currecny dropdown
                dd_currency_s: [],//currecny dropdown
                arry_holdcur: [],
                dd_agentgroup2: [],
                bool_CV: false, // Check Validation
                arry_bl: [], //Bank List
                obj_bank: [], //Add Bank
            }
        },
        validations: {
            obj_bank: {
                AGIT: { required },
                BN: { required },
                MIND: { required },
                MAXD: { required },
                MINW: { required },
                MAXW: { required },
                TD: { required },
                TW: { required },
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
        },
        methods: {
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            checkStatus(RS) {
                var a = this.$parent.checkStatus(RS);
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getBankList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getBankList();
            },
            AgentGroupChange(value) {
                var that = this;
                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                }
                this.dd_currency_s = [];
                var that = this;
                this.getDataApi(`/api/dd/cur/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency_s.push({ id: 'all', label: "All Currency", children: d.dropdownlist });
                        }
                    });
            },
            getDropdownList() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup2 = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup2[0].children == undefined) {
                                var at = 0;
                                at = that.dd_agentgroup2[0].id.split("-")[0];
                                if (at == 3 && that.dd_agentgroup.length < 2) {
                                    that.obj_holdAGIT = that.dd_agentgroup2[0].id;
                                    that.AgentGroupChange(that.obj_holdAGIT);
                                }
                            }

                            if (that.dd_agentgroup2.length > 0) {
                                that.dd_agentgroup2.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
                //this.getDataApi(`/api/dd/cur/0/1`,
                //    function (d, s) {
                //        if (s) {
                //            that.dd_currency_s[0].children = d.dropdownlist
                //            that.dd_currency_s[0].children = that.dd_currency_s[0].children.splice(1);
                //        }
                //    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            checkData(data) {
                if (data == null) {
                    return "USD"
                } else {
                    return data;
                }
            },

            getBankList() {
                this.bool_fullLoading = true;
                var that = this;
                // var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                // for (var i = 0; i < this.str_FV.length; i++) {
                //     if (this.str_FV[i].FV) {
                //         if (path) {
                //             path += "&";
                //         }
                //         path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                //     }
                // };
                var agi = 0;
                var cur = 0;
                if (that.obj_holdAGIT != null && that.arry_holdcur != "") {
                    var agi2 = that.obj_holdAGIT.split("-");
                    agi = agi2[1];
                    cur = that.arry_holdcur;
                    that.bool_isSearch = true;
                } else {
                    that.bool_isSearch = false;
                };

                //this.getDataApi(`/api/bbalance/l?${agi}/?${that.arry_holdcur}`,
                this.getDataApi(`/api/bbalance/l/${agi}/${cur}`,
                    function (d) {
                        that.bool_fullLoading = false;
                        that.arry_bl = d;
                        that.resizeTableHead();
                    });
            },
            setBankList(data) {   // this out put at Bank.js and this output after get list
                this.arry_bl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            addBank() {
                var d = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGIT: null,
                    BN: "",
                    TD: 0,
                    TW: 0,
                    MIND: 0,
                    MAXD: 0,
                    MINW: 0,
                    MAXW: 0,
                    BL: ""
                };
                this.bool_CV = false;
                this.setBank(d);
            },
            // editBank(id) {
            //     this.bool_fullLoading = true;
            //     var that = this;
            //     this.getDataApi(`/api/bank/g/${id}`,
            //         function (d, s) {
            //             that.bool_fullLoading = false;
            //             if (s) {
            //                 that.obj_bank=d.D;

            //                 if (that.obj_bank.AGI != 0) {
            //                         that.obj_bank.AGIT = "3-" + that.obj_bank.AGI;
            //                         that.AgentGroupChange(that.obj_bank.AGIT);
            //                     }
            //                 that.bool_isAMV = true;

            //             }
            //         });

            // },
            setBank(data) {
                this.obj_bank = data;
                this.bool_isAMV = true;
            },
            saveBank() {
                this.bool_CV = true;
                this.$v.obj_bank.$touch();
                if (!this.$v.obj_bank.$error) {
                    this.bool_fullLoading = true;
                    var that = this;
                    if (this.obj_bank.AGIT != "") {
                        var agi = this.obj_bank.AGIT.split("-");
                        this.obj_bank.AGI = agi[1];
                    }
                    this.postDataApi(`/api/bank/s`, this.obj_bank,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getBankList();
                            }
                        });
                }
            },
            removeBank(aRow) { //remove
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var obj = {
                            i: aRow.I,
                            uts: aRow.UTS
                        };

                        this.postDataApi(`/api/bank/d`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getBankList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);

                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const allHeaderRows = this.$el.querySelectorAll('#tHead .custom-table thead tr');

                if (!allHeaderRows.length) return; // Early return if no header rows

                tables.forEach((table) => {
                    let nestedIndex = 0;

                    // Collect body cells from the first row
                    const bodyCells = Array.from(table.querySelectorAll('tbody tr:first-child td'));
                    if (!bodyCells.length) return; // Early return if no body cells

                    // Reset all widths before applying new ones
                    const bodyCellElements = table.querySelectorAll('tbody tr td');
                    [...allHeaderRows[0].querySelectorAll('th'), ...bodyCellElements].forEach(cell => cell.style.width = '');

                    // Apply widths to header and body cells
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        const isNested = [2,3,4,5].includes(index);
                        const headerRow = isNested ? 2 : 1;
                        const headerCells = this.$el.querySelectorAll(`#tHead .custom-table thead tr:nth-child(${headerRow}) th`);

                        let headerCell = headerCells[isNested ? nestedIndex : index];
                        // Update header cell styles
                        if (headerCell) {
                            headerCell.style.width = width;
                        }

                        // Update body cell styles for the corresponding column
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach((td) => {
                            td.style.width = width;
                        });

                        // Increment nestedIndex for nested columns
                        if (isNested) nestedIndex++;
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },

        },
        watch: {
            bool_isSort(newValue) {
                this.getBankList();
            },
            getLanguage() {
                this.getBankList();
            },
        },
        created() {
            this.$parent.showSubMenu = 'B';
            this.$parent.showActiveMenu = 'B.BB';
            this.getBankList();
            this.getDropdownList();
        },
        mounted() {

        },
    }

</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Banks/BankBalance.vue